import React, { useState } from 'react';
import { Box, Button, Text, Flex, Container } from '@radix-ui/themes';
import { useParams, useNavigate } from 'react-router-dom';

const UploadEmployee = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (
      selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
      selectedFile.type === 'application/vnd.ms-excel'
    )) {
      setFile(selectedFile);
    } else {
      alert('Please select a valid Excel file');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert('Please select a file first');
      return;
    }

    const formData = new FormData();
    formData.append('excel', file);

    try {
      setUploading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/uploadEmployee`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      
      if (response.ok) {
        alert('Upload and processing successful!');
        setFile(null);
      } else {
        throw new Error(data.error || 'Upload failed');
      }
    } catch (error) {
      alert('Error: ' + error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Container size="2">
      <Box style={{ padding: '2rem' }}>
        <Flex justify="between" align="center" mb="4">
            <Text size="6" weight="bold">อัปโหลดข้อมูลพนักงาน</Text>
            <Flex gap="2">
                <Button onClick={() => navigate(`/backend/lessons`)} style={{ cursor: 'pointer' }}>
                    กลับไปบทเรียนทั้งหมด
                </Button>
            </Flex>
        </Flex>
        
        <form onSubmit={handleSubmit}>
          <Flex direction="column" gap="4">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              id="excel-upload"
            />
            
            <Button 
              type="button"
              variant="outline" 
              onClick={() => document.getElementById('excel-upload').click()}
            >
              เลือกไฟล์ข้อมูลพนักงาน (Excel)
            </Button>

            {file && (
              <Text size="2">
                Selected file: {file.name}
              </Text>
            )}

            <Button 
              type="submit"
              disabled={!file || uploading}
              variant="solid"
            >
              {uploading ? 'กำลังดำเนินการ...' : 'อัปโหลดและดำเนินการ'}
            </Button>
          </Flex>
        </form>
      </Box>
    </Container>
  );
};

export default UploadEmployee;